import { Box, Typography } from "@mui/material";
import { GlobalContext } from "../Context";
import LoadingWheel from "../LoadingWheel";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import PlayerImage from "../PlayerImage/PlayerImage";
import { green, purple, white } from "../../../theme/colours";
import { TotalIcon, TrophyIcon } from "../Icons";

const ProfileCardMini = ({ userTotal, avatarSource, orgRank, src }) => {
  const { t } = useTranslation("Dashboard");
  const { mobileView, tabletView, desktopView, userState } =
    useContext(GlobalContext);
  const isLoad = userState && userTotal !== null && orgRank !== undefined;
  const miniProfileCardStyle = {
    maxWidth: desktopView ? "22rem" : tabletView ? "49%" : "100%",
    width: src
      ? tabletView
        ? "auto"
        : "100%"
      : tabletView
      ? "49%"
      : mobileView
      ? "100%"
      : "auto",
    flex: 1,
    mr: src && tabletView && "2%",
    borderRadius: "20px",
    minHeight: !src && !mobileView ? "auto" : "7.5rem",
    background: `linear-gradient(90deg, ${white} 0%, ${green[3]} 80%)`,
    border: `4px solid ${green[3]}`,
    p: src ? "1% 1% 1% 1rem" : mobileView ? "1% 10% 1% 1rem" : "1% 3% 1% 1rem",
    alignItems: "center",
    display: "flex",
    mb: mobileView && "1rem",
  };
  const playerImageStyle = {
    "& > div": {
      backgroundColor: "#EBE4F4",
      p: "4px",
    },
    "& img": {
      p: "3px",
    },
    mr: "1rem",
  };
  const nameBoxStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1,
  };
  const nameTextStyle = {
    fontWeight: 700,
    fontSize: "1rem",
  };
  const userScoreBoxStyle = {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    alignItems: "flex-end",
    mt: "0.5rem",
  };
  const scoreBox = {
    display: "flex",
    alignItems: "center",
  };
  const scoreIconStyle = { fill: green[2], width: src ? "21px" : "25px" };
  const trophyIconStyle = {
    fill: purple[1],
    width: src ? "15px" : "18px",
  };
  const miniCardScoreTextStyle = {
    display: "flex",
    alignItems: "center",
  };
  const altScoreTextStyleU = {
    fontWeight: 700,
    pl: "0.25rem",
    color: purple[1],
    opacity: 0.5,
  };
  const altScoreTextStyleNo = {
    fontWeight: 700,
    pl: "0.25rem",
    fontSize: "0.8rem",
    lineHeight: "1.5",
  };
  const altScoreTextStyleO = {
    fontWeight: 700,
    pl: "0.25rem",
    lineHeight: 0,
    fontSize: "0.875rem",
  };
  const parentBoxStyle = {
    display: "flex",
    flexDirection: "column",
    "&:first-of-type": {
      mr: "1rem",
    },
  };
  const descSTextStyle = {
    mt: "0.25rem",
    fontWeight: 700,
    color: green[2],
  };
  const descGTextStyle = {
    mt: "0.1rem",
    fontWeight: 700,
    color: purple[1],
  };

  return (
    <Box sx={miniProfileCardStyle}>
      {avatarSource && (
        <PlayerImage
          styles={playerImageStyle}
          type={userState?.avatar}
          width={"3.5rem"}
        />
      )}
      <Box sx={nameBoxStyle}>
        {isLoad ? (
          <>
            <Typography sx={nameTextStyle}>
              {userState?.fn} {userState?.ln}
            </Typography>
            <Box sx={userScoreBoxStyle}>
              {userTotal > 0 ? (
                <>
                  <Box sx={parentBoxStyle}>
                    <Box sx={scoreBox}>
                      <TotalIcon style={scoreIconStyle} />
                      <Typography sx={altScoreTextStyleO} color={green[2]}>
                        {userTotal}
                      </Typography>
                    </Box>
                    <Typography sx={descSTextStyle}>
                      {t("yourScore")}
                    </Typography>
                  </Box>
                  <Box sx={parentBoxStyle}>
                    <Box sx={scoreBox}>
                      <TrophyIcon style={trophyIconStyle} />
                      <Box sx={miniCardScoreTextStyle}>
                        <Typography sx={altScoreTextStyleO} color={purple[1]}>
                          {orgRank?.rank ? "#" + orgRank.rank : "N/A"}
                        </Typography>
                        <Typography sx={altScoreTextStyleU}>
                          {orgRank?.rank && " /" + orgRank.numUsers}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography sx={descGTextStyle}>
                      {t("allTrypsters")}
                    </Typography>
                  </Box>
                </>
              ) : (
                <Typography sx={altScoreTextStyleNo}>
                  {t("noScores")}
                </Typography>
              )}
            </Box>
          </>
        ) : (
          <LoadingWheel width={2} />
        )}
      </Box>
    </Box>
  );
};

export default ProfileCardMini;
